'use client'

import { useTranslations } from "next-intl";
import FloatDialog from "./_floatDialog";

export default function FloatSharePopupMessage({ show, setShow }: { show: boolean, setShow: Function }) {

    const a = useTranslations("Sentence")

    return (
        <FloatDialog
            show={show}
            setShow={setShow}
            className="shere-popup" >

            <FloatDialog.Head>{a("PopupBlock_title")}</FloatDialog.Head>
            <FloatDialog.Body>

                <div
                    style={{ background: '#fff', padding: 16, width: 360, borderRadius: 12 }}
                    onClick={e => e.stopPropagation()}
                >
                    <p style={{ margin: '0 0 8px', fontSize: 14, lineHeight: 1.5 }}>
                        {a("PopupBlock_Method")}
                    </p>
                    <ul style={{ fontSize: 13, lineHeight: 1.6, margin: '0 0 12px 16px' }}>
                        <li>{a.rich("PopupBlock_Chrome", { b: (chunks)=> <b>{chunks}</b>, i: (chunks)=> <i>{chunks}</i> })}</li>
                        <li>{a.rich("PopupBlock_Android", { b: (chunks)=> <b>{chunks}</b>, i: (chunks)=> <i>{chunks}</i> })}</li>
                        <li>{a.rich("PopupBlock_IOS", { b: (chunks)=> <b>{chunks}</b>, i: (chunks)=> <i>{chunks}</i> })}</li>
                    </ul>
                </div>
            </FloatDialog.Body>
        </FloatDialog>
    )
}